export default {
    EMP_LOGIN: "user/LOGIN",
    EMP_LOGOUT: "user/LOGOUT"
}